<div class="tableFixHead">
  <table id="tool-settings-table" class="table" [ngClass]="headers.tableClasses">
    <thead>
      <tr>
        <th *ngIf="headers.selectable">
          <input
            type="checkbox"
            (change)="handleSelectAll($event)"
            [indeterminate]="selected.length > 0 && selected.length !== totalItems"
            [checked]="selected.length > 0" />
        </th>
        <th
          scope="col"
          *ngFor="let column of headers.columns"
          [ngClass]="column.headerClasses"
          [style]="column.headerStyles">
          <a *ngIf="column.sortable; else nonSortable" href="javascript:;" (click)="triggerAction('sort', column.name)">
            {{ column.label }}
            <i
              [ngClass]="{
                fas: true,
                'fa-sort-up': sort.name === column.name && sort.direction === 'asc',
                'fa-sort-down': sort.name === column.name && sort.direction === 'desc',
                sorted: sort.name === column.name
              }"></i>
          </a>
          <ng-template #nonSortable>
            <span>
              {{ column.label }}
            </span>
          </ng-template>
        </th>
        <th *ngIf="headers?.statusToggle">
          <a href="javascript:;" (click)="triggerAction('sort', 'enabled')">
            Status
            <i
              [ngClass]="{
                fas: true,
                'fa-sort-up': sort.field === 'enabled' && sort.direction === 'asc',
                'fa-sort-down': sort.field === 'enabled' && sort.direction === 'desc',
                sorted: sort.field === 'enabled'
              }"></i>
          </a>
        </th>
        <th *ngIf="headers?.rowActions.length" class="text-right">Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of rows">
        <tr
          #rowRef
          (click)="headers.click && headers.click($event, row, rowRef, snapshotRef)"
          [ngClass]="{ clickable: headers.click }">
          <td *ngIf="headers.selectable">
            <input
              type="checkbox"
              [value]="row.id"
              [checked]="selected?.includes(row.id)"
              (change)="handleCheckbox($event)" />
          </td>
          <td *ngFor="let column of headers.columns" [ngClass]="column.columnClasses" [style]="column.columnStyles">
            <span *ngIf="column.popover && column.popover(row); else contentColumn" class="alert-code">
              <span class="alert-code-icon"><span>i</span></span>
              <span class="alert-code-content">{{ printRowData(column.property, row, column.defaultValue) }}</span>
            </span>
            <ng-template #contentColumn>
              <a
                *ngIf="column.show && column.show(row, meta) && column.link; else dataColumn"
                class="link"
                [routerLink]="column.link(row, meta)"
                [ngClass]="column.dataClasses && column.dataClasses(row)"
                [style]="column.dataStyles">
                {{ printRowData(column.property, row, column.defaultValue) }}
              </a>
              <ng-template #dataColumn>
                <span
                  data-toggle="tooltip"
                  data-placement="top"
                  title="{{ printRowData(column.property, row) }}"
                  *ngIf="!column.component"
                  [ngClass]="column.dataClasses && column.dataClasses(row)"
                  [style]="column.dataStyles">
                  {{ printRowData(column.property, row) }}
                </span>
                <app-tool-status *ngIf="column.component === 'tool-status'" [data]="printRowData(column.property, row)">
                </app-tool-status>
                <span
                *ngIf="column.component === 'inventory-icon' && isInventoryWithinLast12Months(row)"
                class="inventory-icon-wrapper"
                style="cursor: pointer; display: inline-block;"
                data-toggle="tooltip"
                data-placement="bottom"
                [title]="getInventoryTooltip(row)"
                (mouseenter)="onInventoryHover(row)"
              >
                <img src="assets/images/icon/icon_check.svg" alt="Inventory Check" style="width:24px;height:24px;vertical-align:middle;" />
              </span>
              </ng-template>
            </ng-template>
          </td>
          <td *ngIf="headers?.statusToggle">
            <app-toggle
              [enabled]="row.enabled"
              [allowChanges]="true"
              (action)="triggerAction($event, row)"></app-toggle>
          </td>
          <td *ngIf="headers?.rowActions.length" class="text-right d-flex justify-content-end flex-nowrap">
            <span *ngFor="let action of headers.rowActions">
              <app-action-button
                *ngIf="action.show(row, meta)"
                [action]="action"
                (submitAction)="triggerAction($event, row)"
                (click)="action.click && action.click($event, row)"></app-action-button>
            </span>
          </td>
        </tr>
        <tr class="collapse" #snapshotRef>
          <td colspan="100%">
            <app-tool-snapshot [row]="row"></app-tool-snapshot>
          </td>
        </tr>
      </ng-container>
      <tr *ngIf="rows.length === 0">
        <td [attr.colspan]="headers.columns.length + 2" class="no-results">
          {{
            headers.noResultsMessage
              ? headers.noResultsMessage
              : source === 'transfer'
                ? 'Enter Search Criteria'
                : 'No results found.'
          }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
